import { z } from "zod";

export const navigationBridgeEvent = "froppio:navigation";

const envelope = {
  channel: z.literal(navigationBridgeEvent),
  version: z.literal(1),
};

export const HostNavigationStateSchema = z.object({
  ...envelope,
  type: z.literal("state"),
  canGoBack: z.boolean(),
  busy: z.boolean(),
});

export const HostNavigationCommandSchema = z.object({
  ...envelope,
  type: z.enum(["back", "sync"]),
});

export type HostNavigationState = z.infer<typeof HostNavigationStateSchema>;
export type HostNavigationCommand = z.infer<typeof HostNavigationCommandSchema>;
